module.exports = __webpack_public_path__ + "static/media/subtitle_experience.a9fb025f.svg";